export default __webpack_public_path__ + "static/media/10.7e99c2fc.png";